export default __webpack_public_path__ + "static/media/img_typelist03.41ecea12.png";